import { FC } from 'react';
import { CommonPageTDK, DynamicHead } from '@lemon8/web-app-shared/ssr';
import { useAtomValue } from 'jotai';
import { $PageLevelTraffic } from 'shared/atoms';
import { usePoiTDK } from '../shared/use-poi-tdk';

const PoiCanonical: FC = () => {
  const { canonicalUrl } = useAtomValue($PageLevelTraffic);

  return (
    <DynamicHead>
      <link rel="canonical" href={canonicalUrl} />
    </DynamicHead>
  );
};

class PageTDK extends CommonPageTDK {
  CanonicalLink = () => <PoiCanonical />;
}

export const PoiTDK: FC = () => {
  return <PageTDK {...usePoiTDK()} />;
};
